import { Instance } from 'mobx-state-tree';
import { DeleteCustomFieldDtoModelBase } from './DeleteCustomFieldDtoModel.base';

/* The TypeScript type of an instance of DeleteCustomFieldDtoModel */
export interface DeleteCustomFieldDtoModelType extends Instance<typeof DeleteCustomFieldDtoModel.Type> {}

/* A graphql query fragment builders for DeleteCustomFieldDtoModel */
export {
  selectFromDeleteCustomFieldDto,
  deleteCustomFieldDtoModelPrimitives,
  DeleteCustomFieldDtoModelSelector,
} from './DeleteCustomFieldDtoModel.base';

/**
 * DeleteCustomFieldDtoModel
 */
export const DeleteCustomFieldDtoModel = DeleteCustomFieldDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
